const rootReducer = (state) => {
  return state || {};
};

export default rootReducer;



// WEBPACK FOOTER //
// ./reducers/index.jsx